<!-- 登录页面 -->
<template>
  <!-- <el-tabs v-model="activeName" @tab-click="handleClick" stretc>
    <el-tab-pane :label="item.label" :name="item.name" v-for="item in labelList " :key="item.name">
      <component :is="item.com" @closeAlert="handleClose"></component>
    </el-tab-pane>
  </el-tabs>-->
  <!-- <div>
    <div class="logNames">用户登录</div>
    <firstLogin @closeAlert="handleClose"></firstLogin>
  </div>-->
  <div>
    <div class="logNames">用户登录</div>
    <div class="specialnav">
      <div
        v-for="(item,index) in labelList "
        :key="index"
        class="navli item"
        @click="swichNav(index)"
        :class="[currentTab===index ? 'active' : '']"
      >{{item.label}}</div>
    </div>

    <firstLogin v-if="currentTab==0" @closeAlert="handleClose"></firstLogin>
    <thirdLogin v-if="currentTab==1" @closeAlert="handleClose"></thirdLogin>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import firstLogin from './components/First';
import thirdLogin from './components/Third';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { firstLogin, thirdLogin },
  data() {
    //这里存放数据
    return {
      dialogVisible: true,
      currentTab: 0,
      labelList: [{ label: '账号登录' }, { label: '数字证书登录' }],
      // activeName: 'first',
      // labelList: [
      //   {
      //     name: 'first',
      //     label: '账号登录',
      //     com: 'firstLogin',
      //   },
      //   {
      //     name: 'third',
      //     label: '数字证书登录',
      //     com: 'thirdLogin',
      //   },
      // ],
    };
  },
  
  created() {
    this.currentTab = 0;
  },
  //方法集合
  methods: {
    swichNav(val) {
      this.currentTab = val;
    },
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    handleClose(tab, event) {
      this.dialogVisible = false;
      // window.location.reload();
      this.currentTab = 0;
      this.$emit('closeAlert');
    },
  },
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

.login-wrap {
  box-sizing: border-box;

  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
}
.logNames {
  text-align: center;
  padding: 10px 0 10px 0;
  font-size: 27px;
  letter-spacing: 3px;
  font-weight: bold;
  font-family: '华文楷体 Bold', '华文楷体', sans-serif;
  color: #1492ff;
}

/*顶部导航样式*/
.specialnav {
  flex: none;
  display: flex;
  width: 100%;
  height: 44px;
  align-items: center;
  box-sizing: border-box;
  padding: 0 35px;
  white-space: nowrap; /*文本不会换行，文本会在在同一行上继续*/
  z-index: 1000;
  background-color: #fff;
  margin: 10px 0 20px 0;
  border-bottom: 1px solid #f2f2f2;
}
.specialnav .item {
  position: relative;
  flex: auto;
  text-align: center;
  line-height: 44px;
  font-size: 16px;
}
.specialnav .item.active:after {
  content: '';
  display: block;
  position: absolute;
  bottom: 1px;
  left: 50%;
  right: 0;
  margin-left: -45px;
  height: 2px;
  width: 95px;
  background: #a30014;
}
.specialnav .item.active {
  color: #a30014;
}
.navli {
  margin-right: 15px;
  color: #333;
  font-weight: bold;
  cursor: pointer;
}
</style>